import { userManagementState } from './user-management.state';
import { userManagementActions } from './user-management.action';
import { userManagementMutations } from './user-management.mutation';

export default {
  namespaced: true,
  state: userManagementState,
  getters: {},
  actions: userManagementActions,
  mutations: userManagementMutations,
};
